import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import SingleEvent from "../../components/Event";
import { Pagination } from "../../components/admin/common/PaginationNumber";

const EventMain = ({
  categories = [],
  selectedCategory,
  events = [],
  hasMore,
  canGoPrev,
  currentPage = 1,
  totalPages = 1,
  totalCount = 0,
  isLoading,
  onTabClick,
  onNext,
  onPrev,
  onPageJump,
  onFirstPage,
  onLastPage,
}) => {
  const currentCategory = categories.find((c) => c.value === selectedCategory);
  const displayEvents = events;

  return (
    <main>
      <Breadcrumb title="Events" />
      <div className="it-event-2-area it-event-style-3 p-relative pt-90 pb-90">
        <div className="container">
          <div className="row">
            <div className="it-course-details-wrap">
              <div className="it-course-details-nav pb-50">
                <nav>
                  <ul className="nav nav-tab" id="nav-tab" role="tablist">
                    {categories.map((category) => (
                      <li
                        key={category.value}
                        onClick={() => onTabClick(category.value)}
                      >
                        <button
                          className="mb-3"
                          style={{
                            backgroundColor:
                              category.value === selectedCategory
                                ? "#fde047"
                                : "transparent",
                            color: "#000",
                            fontWeight:
                              category.value === selectedCategory
                                ? "bold"
                                : "normal",
                            padding: "8px 16px",
                            borderRadius: "6px",
                            border:
                              category.value === selectedCategory
                                ? "none"
                                : "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "40px",
                            cursor: "pointer",
                          }}
                        >
                          {category.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>

              <div className="tab-content" id="nav-tabContent">
                {isLoading ? (
                  <div className="col-12">
                    <div className="text-center py-5">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading events...</span>
                      </div>
                      <p className="mt-3">Loading events...</p>
                    </div>
                  </div>
                ) : currentCategory ? (
                  <div key={currentCategory.value} className="tab-pane active">
                    {/* Pagination Info */}
                    {totalCount > 0 && (
                      <div className="row mb-4">
                        <div className="col-12">
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-muted">
                              Showing page {currentPage} of {totalPages} (
                              {totalCount} total events)
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      {displayEvents.length > 0 ? (
                        displayEvents.map((event) => {
                          const dateObj = new Date(event.date);
                          const day = dateObj
                            .getDate()
                            .toString()
                            .padStart(2, "0");
                          const month = dateObj.toLocaleString("default", {
                            month: "long",
                          });
                          const year = dateObj.getFullYear();

                          return (
                            <div
                              key={event._id}
                              className="col-xl-4 col-lg-6 col-md-6 mb-30"
                            >
                              <SingleEvent
                                eventId={event._id}
                                eventImage={event.image}
                                eventDate={day}
                                eventMonth={month}
                                eventYear={year}
                                title={event.title}
                                description={
                                  event.description
                                    ?.replace(/<[^>]*>/g, "")
                                    ?.split(" ")
                                    .slice(0, 20)
                                    .join(" ") +
                                  (event.description
                                    ?.replace(/<[^>]*>/g, "")
                                    ?.split(" ").length > 20
                                    ? "..."
                                    : "")
                                }
                                hasArrow
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div className="col-12">
                          <div className="text-center py-5">
                            <i className="fa-regular fa-calendar-xmark fa-3x text-muted mb-3"></i>
                            <p className="h5">
                              No events found in this category.
                            </p>
                            <p className="text-muted">
                              Try selecting a different category.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {totalPages > 1 && (
                      <div className="row mt-5">
                        <div className="col-xl-12">
                          <Pagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={onPageJump}
                            showPages={5}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default EventMain;
